import { FC, useCallback, useLayoutEffect, useRef, useState } from 'react';

import { LoadMoreButton } from '../../../../../components/load-more-button/index';
import { CAP_TABLE_SCROLL_SELECTOR } from '../cap-table-sticky-classes';

export type LoadMoreItemProps = {
  loadCount: number;
  onLoadMore: () => void;
  onShowLess: () => void;
  showLess: boolean;
  viewByAll: boolean;
};

export const LoadMoreItem: FC<LoadMoreItemProps> = ({
  loadCount,
  onLoadMore,
  onShowLess,
  showLess,
  viewByAll,
}) => {
  const barRef = useRef<HTMLDivElement>(null);
  const [visibleBar, setVisibleBar] = useState({ left: 0, width: 0 });

  const syncVisibleBar = useCallback(() => {
    const scrollParent = barRef.current?.closest(CAP_TABLE_SCROLL_SELECTOR);
    if (!(scrollParent instanceof HTMLElement)) return;

    const next = { left: scrollParent.scrollLeft, width: scrollParent.clientWidth };
    setVisibleBar((current) =>
      current.left === next.left && current.width === next.width ? current : next,
    );
  }, []);

  useLayoutEffect(() => {
    syncVisibleBar();

    const scrollParent = barRef.current?.closest(CAP_TABLE_SCROLL_SELECTOR);
    if (!(scrollParent instanceof HTMLElement)) return undefined;

    scrollParent.addEventListener('scroll', syncVisibleBar, { passive: true });
    const resizeObserver = new ResizeObserver(syncVisibleBar);
    resizeObserver.observe(scrollParent);

    return () => {
      scrollParent.removeEventListener('scroll', syncVisibleBar);
      resizeObserver.disconnect();
    };
  }, [syncVisibleBar]);

  return (
    <div className="relative bg-brand-25 py-4 shadow-[inset_0px_-1px_0px_0px_#F2F4F7]" ref={barRef}>
      {viewByAll && (
        <span
          aria-hidden
          className="pointer-events-none absolute -top-px bottom-0 left-0 w-0.5 bg-brand-700"
        />
      )}
      <div
        className="flex justify-center px-4"
        style={{
          marginLeft: visibleBar.left,
          width: visibleBar.width || '100%',
        }}
      >
        <LoadMoreButton
          count={loadCount}
          onLoadMore={onLoadMore}
          onShowLess={onShowLess}
          showLess={showLess}
        />
      </div>
    </div>
  );
};
